import OneEdition from './components/one_edition'
import TwoEdition from './components/two_edition'
import ThreeEdition from './components/three_edition'
import FourEdition from './components/four_edition'
import app from './keyCustomers_app'
import Axios from "axios"

export default {
  data() {
    return {
      smallViewPort: false,
      swiperOptions: {
        speed: 800,
        direction: "vertical",
        mousewheel: true,
        parallax: true,
        pagination: {
          el: ".full-swiper-pagination",
          bulletActiveClass: "full-swiper-pagination-custom-bullet-active",
          clickable: true,
          renderBullet: (index, className) => {
            return `<span class="${className} full-swiper-pagination-custom-bullet">${
              this.swiperList[index].title
              }</span>`;
          }
        },
        navigation: {
          nextEl: ".pagenation-bar-next",
          prevEl: ".pagenation-bar-prev"
        }
      },
      swiperList: [
        {
          title: "01"
        },
        {
          title: "02"
        },
        {
          title: "03"
        },
        {
          title: "04"
        }
      ],


      tzData:{
        name:'',//姓名
        telephone:'',//
        email:'',//
        city:'成都',//
        businessType:'大客户',//业务类型 1-大客户 2-投资 3-加盟
        addCity:'成都',//加盟城市
        addArea:'600㎡以下',//加盟面积
        addCharging:'60kw以下',//充电桩
        addCooperationMode:'建站方案策划',//合作模式
        addEstimatedCost: '50000.00',//加盟预计费用
        path:'/keyCustomers',
      }
    }
  },
  components: {
    OneEdition,
    TwoEdition,
    ThreeEdition,
    FourEdition,
    app,
  },
  computed:{
    result(){
      if(this.hzms){
        return this.mj*10000*0.1
      }else{
        return this.mj*10000*0.04
      }
    }
  },
  watch: {},
  mounted() {},
  methods: {
    handleResize() {
      const windowWidth = document.documentElement.offsetWidth;
      if (windowWidth <= 767) {
        this.smallViewPort = true;
      } else {
        this.smallViewPort = false;
      }
    },
  },
}
